import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;

  label {
    span {
      height: 20px;
    }
  }
`;
